import "./index.scss";
export default function Index({ datas }: { datas: any[] }) {
  return (
    // <div style={{ display: "flex", justifyContent: "center" }}>
    <div className="tagsContainer">
      {datas.map((item: any) => {
        return (
          <div key={item.name} className="tagItem">
            <div
              className="itemColor"
              style={{ backgroundColor: item.color }}
            ></div>{" "}
            {item.name}
          </div>
        );
      })}
    </div>
    // </div>
  );
}
